export default __webpack_public_path__ + "static/media/restox2.d86ea5ae.jpg";